import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface CompanyTenantsData {
  companyName: string | null;
  appId: string | null;
  tenants: string | null;
  audienceId: string | null;
}

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
});

export const tenantsApi = createApi({
  reducerPath: 'tenants',
  baseQuery,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getCompanyTenants: builder.query<CompanyTenantsData[], void>({
      query: () => '/getCompanyTenants',
    }),
  }),
});

export const { useGetCompanyTenantsQuery, useLazyGetCompanyTenantsQuery } =
  tenantsApi;
